import React from "react";
import UserProfileView from '../../../../components/User/UserProfileView';
import UserPageLayout from '../../../../components/User/UserPageLayout';

const UserProfile = () => {

    return (
        <UserPageLayout title="Profile" >
            <UserProfileView />
        </UserPageLayout>
    )
}

export default UserProfile;
